// TEKTELIC
// https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2FgatewayBal.webp?alt=media&token=96051f47-d11a-4e49-8966-b34b915cd5f3

// Kerlink
// https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2FgatewayPhoto.png?alt=media&token=c7c1d59a-6990-4753-9cd2-a177deb94f63

export const Gateways: any[] = [
  {
    id: 'GAMC-GWKerlink-09B9',
    name: 'Parque de la Familia',
    slug: 'pfamilia',
    location: {
      address: 'Parque de la Familia',
      coords: {
        lat: '-17.38693346729293',
        lng: '-66.16361808814895'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FIoT%2Fgateway.png?alt=media&token=7be3335b-ea81-4a97-bfe4-0eaaced1885a'
  },
  {
    id: 'GAMC-GWKerlink-0994',
    name: 'Parque de la Autonomía',
    slug: 'pautonomia',
    location: {
      address: 'Av. Heroínas y C. Castel Quiroga',
      coords: {
        lat: '-17.389085092308864',
        lng: '-66.14254244766464'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FIoT%2Fgateway.png?alt=media&token=7be3335b-ea81-4a97-bfe4-0eaaced1885a'
  },
  {
    id: 'GAMC-GWKerlink-09A1',
    name: 'Islas',
    slug: 'islas',
    location: {
      address: 'Av. Circunvalación y Av. Villaroel',
      coords: {
        lat: '-17.366390137641673',
        lng: '-66.15758627398426'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FIoT%2Fgateway.png?alt=media&token=7be3335b-ea81-4a97-bfe4-0eaaced1885a'
  },
  {
    id: 'GAMC-GWKerlink-09BA',
    name: 'Ex Matadero',
    slug: 'matadero',
    location: {
      address: 'Av. 27 de Agosto',
      coords: {
        lat: '-17.399798487349106',
        lng: '-66.16511370496808'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FIoT%2Fgateway.png?alt=media&token=7be3335b-ea81-4a97-bfe4-0eaaced1885a'
  },
  // {
  //   name: 'FEXCO',
  //   slug: 'fexco',
  //   location: {
  //     address: 'FEXCO',
  //     coords: {
  //       lat: '-17.42105',
  //       lng: '-66.13138'
  //     }
  //   },
  //   photo: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FIoT%2Fgateway.png?alt=media&token=7be3335b-ea81-4a97-bfe4-0eaaced1885a'
  // },
  // {
  //   name: 'Edificio Céspedes',
  //   slug: 'ecespedes',
  //   location: {
  //     address: 'Av. Ayacucho y Av. Heroínas',
  //     coords: {
  //       lat: '-17.39218',
  //       lng: '-66.159238'
  //     }
  //   },
  //   photo: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FIoT%2Fgateway.png?alt=media&token=7be3335b-ea81-4a97-bfe4-0eaaced1885a'
  // },
  // {
  //   name: 'ATB Temporal',
  //   slug: 'atbtemporal',
  //   location: {
  //     address: 'Temporal Norte',
  //     coords: {
  //       lat: '-17.35334',
  //       lng: '-66.15716'
  //     }
  //   },
  //   photo: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FIoT%2Fgateway.png?alt=media&token=7be3335b-ea81-4a97-bfe4-0eaaced1885a'
  // }
]

export const GatewaysCircleOptions = {
  color: '#47277880',
  fillColor: '#482778',
  fillOpacity: 0.1
};